<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Project Information</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form class="pa-5" v-if="!loading">
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-select v-model="form.governor_theme_id" :items="themeList" :item-text="'theme'" :item-value="'uuid'"
              label="Theme" dense outlined @change="themeChange()"
              :error-messages="serverErrors.governor_theme_id || ''"
              @input="clearServerError('governor_theme_id')"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.venue" label="Venue*" required
              :error-messages="serverErrors.venue || ''"
              @input="clearServerError('venue')"></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <DatePicker :lable="'Date*'" v-model="form.date" :setectVale="form.date" @changeInput="form.date = $event">
            </DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.total_project_cost" label="Actual Total Project Cost (Rs.)*"
              required :error-messages="serverErrors.total_project_cost || ''"
              @input="clearServerError('total_project_cost')"></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.direct_beneficiaries" label="Direct Beneficiaries*"
              type="number" :rules="[v => !!v || 'Required', v => v <= 1000 || 'Maximum 1000']"
              required :error-messages="serverErrors.direct_beneficiaries || ''"
              @input="clearServerError('direct_beneficiaries')"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12" v-if="showLargeTree">
            <v-text-field outlined dense v-model="form.large_tree" label="No of large trees*" required
              :error-messages="serverErrors.large_tree || ''"
              @input="clearServerError('large_tree')"></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12" v-if="showSmallTree">
            <v-text-field outlined dense v-model="form.small_tree" label="No of small trees*" required
              :error-messages="serverErrors.small_tree || ''"
              @input="clearServerError('small_tree')"></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="showNumberOfTrees">
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.number_of_trees" label="Number of Trees*" required
              :error-messages="serverErrors.number_of_trees || ''"
              @input="clearServerError('number_of_trees')"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-textarea outlined dense v-model="form.description" label="Brief Description of the Project*"
              :error-messages="serverErrors.description || ''"
              @input="clearServerError('description')">
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-text-field outlined dense v-model="form.video_url" label="Video URL"
              :error-messages="serverErrors.video_url || ''"
              @input="clearServerError('video_url')">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-file-input outlined dense filled v-model="form.int_report_screenshot" prepend-icon="mdi-paperclip"
              label="Please attach a screenshot of the Lions International Portal Service Project Reporting with Reference No. visible*"
              :rules="[v => !!v || 'International reporting screenshot is required']"
              :error-messages="serverErrors.int_report_screenshot || ''"
              @input="clearServerError('int_report_screenshot')" required></v-file-input>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading || !form.governor_theme_id" block
              @click="submit()">Next</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="succesMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="clossSnackbar" />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { CommonService } from "../../../../services/common-service.js";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker },
  props: ["uuid"],
  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    serverErrors: {},
    snackbar: false,
    succesMsg: "",
    themeList: [],
    showLargeTree: false,
    showSmallTree: false,
    showNumberOfTrees: false,
    envThemes: ['environment_planting_coconut', 'environment_planting_jack_fruit', 'environment_plants_more_than_2_years_lifetime', 'environment_plants_less_than_2_years_lifetime'],
    form: {
      venue: "",
      description: "",
      date: null,
      total_project_cost: null,
      number_of_beneficiaries: null,
      governor_theme_id: null,
      int_report_screenshot: null,
      small_tree: 0,
      large_tree: 0,
      number_of_trees: 0,
      direct_beneficiaries: null,
      video_url: null
    },
    role: localStorage.getItem('role') || null


  }),

  mounted() {
    this.getGovernorThemes();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),

  },

  methods: {
    submit() {
      this.loading = true;
      this.serverErrors = {};
      let fd = new FormData();
      fd.append("int_report_screenshot", this.form.int_report_screenshot);
      fd.append("venue", this.form.venue);
      fd.append("description", this.form.description);
      fd.append("date", this.form.date);
      fd.append("total_project_cost", this.form.total_project_cost);
      fd.append("direct_beneficiaries", this.form.direct_beneficiaries);
      fd.append("governor_theme_id", this.form.governor_theme_id);
      fd.append("small_tree", this.form.small_tree);
      fd.append("large_tree", this.form.large_tree);
      fd.append("number_of_trees", this.form.number_of_trees);
      fd.append("video_url", this.form.video_url);
      ProjectService.createProjectInfo(fd)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.succesMsg = "Success";
            this.snackbar = true;
            this.$router.push({
              name: "ProjectEdit",
              params: { step: 2, uuid: response.data.data.uuid },
            });

            this.reset();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.serverErrors = checkError.fieldErrorFormatting(data);
        });
    },

    themeChange() {
      this.showLargeTree = false;
      this.showSmallTree = false;
      this.showNumberOfTrees = false;

      this.themeList.forEach((value) => {
        if (value.theme_key == 'reforestation' && this.form.governor_theme_id == value.uuid) {
          this.showLargeTree = true;
          this.form.small_tree = 0;
        }
        if (value.theme_key == 'gardening_farming' && this.form.governor_theme_id == value.uuid) {
          this.showSmallTree = true;
          this.form.large_tree = 0;
        }
        if (this.envThemes.includes(value.theme_key) && this.form.governor_theme_id == value.uuid) {
          this.showNumberOfTrees = true;
        }
      });
    },



    getGovernorThemes() {
      if (this.uuid !== null) {
        this.loading = true;
        CommonService.getGovernorThemes()
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.themeList = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.themeList = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    onDismissed() {
      this.errors = null;
      this.serverErrors = {};
    },
    clearServerError(field) {
      this.$delete(this.serverErrors, field);
    },
    clossSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form = [];
    },
  },
};
</script>
